// quickActionsBus.ts — tiny event emitter (clone of toastBus) so non-local UI
// (the ⌘K CommandPalette) can open a quick-action flow without prop drilling.
// <QuickActions> subscribes; anything may call quickActionsBus.open(id).

export type QuickActionId = 'adjust' | 'add-stock' | 'new-adjustment';

type Listener = (id: QuickActionId) => void;

class QuickActionsBus {
  private listeners = new Set<Listener>();

  subscribe(fn: Listener) {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  }

  open(id: QuickActionId) {
    this.listeners.forEach((fn) => fn(id));
  }
}

export const quickActionsBus = new QuickActionsBus();
